import {
    Button, ColorPaletteProp,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Modal, ModalClose,
    ModalDialog,
    Stack,
    Typography
} from "@mui/joy";
import React from "react";
import {useTranslation} from "react-i18next";
import {TransactionStatus} from "../models/transaction";
import {BoxIcon, CheckIcon, Hourglass, LayoutDashboardIcon, XIcon} from "lucide-react";
import IconBoxComponent from "./IconBoxComponent";

type PaymentStatusDialogProps = {
    status?: TransactionStatus
    localizedAmount?: string
    open?: boolean
    onClose?: () => void
    /** Opens the dashboard once the payment went through (signing in on the app if needed). */
    onContinue?: () => void
}

const PaymentStatusDialog = (props: PaymentStatusDialogProps) => {
    const {t} = useTranslation()
    const handleClose = () => {
        props.onClose?.()
        if (props.status === "successful")
            props.onContinue?.()
    }

    const StatusIcon = () => {
        switch (props.status) {
            case "successful":
                return <IconBoxComponent color={"success"} style={{borderRadius: "100%"}}>
                    <CheckIcon style={{fontSize: "60", color: "inherit"}}/>
                </IconBoxComponent>
            case "failed":
            case "cancelled":
                return <IconBoxComponent color={"danger"} style={{borderRadius: "100%"}}>
                    <XIcon style={{fontSize: "60", color: "inherit"}}/>
                </IconBoxComponent>
            case "pending":
                return <IconBoxComponent color={"secondary"} style={{borderRadius: "100%"}}>
                    <Hourglass style={{fontSize: "60", color: "inherit"}}/>
                </IconBoxComponent>
        }
    }
    const statusText: {
        [k in TransactionStatus]?: {
            title: string
            description: string
        }
    } = {
        cancelled: {
            title: t("paymentCancelledTitle"),
            description: t("paymentCancelledDescription")
        },
        failed: {
            title: t("paymentFailedTitle"),
            description: t("paymentFailedDescription")
        },
        successful: {
            title: t("paymentSuccessTitle"),
            description: t("paymentSuccessDescription")
        },
        pending: {
            title: t("paymentPendingTitle"),
            description: t("paymentPendingDescription")
        }
    }

    return <Modal open={props.open}
                  onClose={(ev, reason) => {
                      if (reason === "closeClick")
                          props.onClose?.()
                  }}>
        <ModalDialog sx={{minWidth: {xs: "100%", sm: "30rem"}}} variant="outlined" role="alertdialog">
            <ModalClose/>
            <DialogContent sx={{alignItems: "center", gap: 2}}>
                <StatusIcon/>

                <Stack gap={1}>
                    <Typography level={"h3"} textAlign={"center"}>
                        {statusText[props.status]?.title}
                    </Typography>
                    <Typography level={"body-sm"} textAlign={"center"}>
                        {statusText[props.status]?.description}
                    </Typography>
                </Stack>

            </DialogContent>
            <DialogActions sx={{justifyContent:"center"}}>
                {props.status === "pending" &&
                    <Typography level={"body-xs"} textAlign={"center"}>
                        {t("paymentProcessingNotice")}
                    </Typography>}
                {props.status !== "pending" &&
                    <Button color={"neutral"} variant={"soft"} onClick={handleClose}>
                        {t("closePaymentStatusDialogActionLabel")}
                    </Button>}
            </DialogActions>
        </ModalDialog>
    </Modal>
}


export default PaymentStatusDialog